<div class="family-member-card">
  <div class="family-member-card_actions">
    <button mat-icon-button [matMenuTriggerFor]="actions" sf-aria-label="Global_MemberActions_Aria_Label" *ngIf="canChangeAvatar">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actions="matMenu">
      <button mat-menu-item *ngIf="canEdit" (click)="onEditClicked()" [gtmClick]="getViewLabel('Account_Manage_Members_EditMemberDetails')">
        <adp-label labelKey="Account_Manage_Members_EditMemberDetails"></adp-label>
      </button>
      <button
        mat-menu-item
        *ngIf="canChangeAvatar"
        (click)="onChangeAvatarClicked()"
        [gtmClick]="getViewLabel('Account_Manage_Members_EditMemberColor')">
        <adp-label labelKey="Account_Manage_Members_EditMemberColor"></adp-label>
      </button>
      <button mat-menu-item *ngIf="canDelete" (click)="onDeleteClicked()" [gtmClick]="getViewLabel('Account_Manage_Members_DeleteMember')">
        <adp-label labelKey="Account_Manage_Members_DeleteMember"></adp-label>
      </button>
    </mat-menu>
  </div>
  <div class="family-member-card_avatar">
    <div>
      <pgh-avatar
        name="{{ familyMember.firstName + ' ' + familyMember.lastName }}"
        color="{{ familyMember?.profileColor }}"
        size="100"></pgh-avatar>
      <!--<img [src]="familyMember?.avatarUrl || './assets/images/avatars/desktop.png'" alt="{{familyMember.firstName}}'s Avatar" />-->
    </div>
  </div>
  <div class="family-member-card_info">
    <div class="family-member-card_info-name cls_mask">{{ familyMember.firstName }} {{ familyMember.lastName }}</div>
    <div class="family-member-card_info-phone cls_mask">{{ familyMember.phoneNumber | pghNumberMask: 'phone' }}</div>
  </div>
</div>
